export default "__VITE_ASSET__41fd4d5b__"